// extracted by mini-css-extract-plugin
module.exports = {"root":"_7c9a64","itemsList":"_2c18d7","item":"_0f9131","active":"_329099","mainLink":"_18ffba","subLink":"_b50f31","subMenu":"_0d25af"};